module.exports = __webpack_public_path__ + "img/ecommerce-checkout-laptop-rafiki@2x.e64495bd.png";